import axios from "axios";
import { ReactRenderer } from "@tiptap/react";
import tippy from "tippy.js";
import MentionList from "./MentionList.jsx";
import { BaseUrl } from "../../../../../Container/BaseUrl/BaseUrl.js";

const fetchMentions = async (query) => {
  try {
    const response = await axios.post(
      `${BaseUrl}/users/getagentaddressbook`,
      { emailId: "" },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      }
    );

    if (response.data.success) {
      const allItems = response.data.data.map((item) => item.email);
      return allItems
        .filter((item) => item.toLowerCase().includes(query.toLowerCase()))
        .slice(0, allItems.length);
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching mentions:", error);
    return [];
  }
};

export default {
  items: async ({ query }) => {
    if (query.length === 0) return [];
    return await fetchMentions(query);
  },

  render: () => {
    let component;
    let popup;

    return {
      onStart: (props) => {
        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) return;

        popup = tippy("body", {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: "manual",
          placement: "bottom-start",
        });
      },

      onUpdate(props) {
        component.updateProps(props);

        if (!props.clientRect) return;

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        });
      },

      onKeyDown(props) {
        if (props.event.key === "Escape") {
          popup[0].hide();
          return true;
        }

        return component.ref?.onKeyDown(props);
      },

      onExit() {
        popup[0].destroy();
        component.destroy();
      },
    };
  },
};
